"use client";
import { TPartner } from "@/app/types/partnerPageTypes";
import PartnerCard from "./PartnerCard";

const PartnersSection = ({
	data,
	last,
	optimizedImage,
}: {
	last: boolean;
	data: TPartner[];
	optimizedImage?: boolean;
}) => {
	return (
		<div
			className={`
            lg:border-solid
            lg:border-t-[1px]
            lg:border-oBlack-10
            lg:border-b-[0px]
            border-solid  
            border-b-[1px] 
            border-oBlack-10 
            flex 
            flex-col
            mx-[1.25rem] 
            bg 
            h-[100%]
            lg:grid lg:grid-cols-3 lg:gap-[0rem] 
            lg:mx-[2.75rem]
            ${last && "!border-b-0"}
            
    `}
		>
			{data.map((partner: TPartner, index: number) => (
				<PartnerCard
					key={index}
					data={partner}
					lastCard={last && index === data.length - 1}
					optimizedImage={optimizedImage}
				/>
			))}
		</div>
	);
};

export default PartnersSection;
